var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-info-block"},[_c('h6',{staticClass:"title"},[_vm._v(_vm._s(_vm.service.title))]),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.service.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }